import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/(site)/experiences/[id]/page.tsx");
